import ModalDescription from 'shared/components/Modal/component/modalDescription';
import ModalFooter from 'shared/components/Modal/component/modalFooter';
import ModalTitle from 'shared/components/Modal/component/modalTitle';
import './styles.scss';

interface ModalDefaultContentProps {
	icon?: any;
	title: string;
	buttons: {
		disabled?: boolean;
		text: string | JSX.Element;
		onClick: () => void;
		btnType?: string;
		type: string;
	}[];
	description?: string;
	children?: JSX.Element;
}

export const ModalDefaultContent = ({ title, buttons, icon, description, children }: ModalDefaultContentProps) => {
	return (
		<div className="modalDefaultContent">
			{icon && <div className="modalDefaultContent__icon">{icon}</div>}
			<ModalTitle text={title} alingment="center" />
			{description && <ModalDescription description={description} />}
			{children}
			<ModalFooter buttons={buttons} />
		</div>
	);
};

export default ModalDefaultContent;
